import { createSlice } from '@reduxjs/toolkit'

export const hasAppInstalled = createSlice({
  name: 'hasAppInstalled',
  initialState: false,
  reducers: {
    setHasAppInstalled: (state, action) => {
      // Update state only if the action payload is true (this will be called only for the initial response)
      if (action?.payload === true) {
        return true
      }
      return state
    },
  },
})

export const { setHasAppInstalled } = hasAppInstalled.actions
